import { useState, useEffect } from 'react';
import { RotateCcw } from 'lucide-react';

export function UpdateBanner() {
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    let initialBuildId: string | null = null;
    
    // Function to check for updates
    const checkForUpdates = async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now(), {
          cache: 'no-store'
        });
        if (!response.ok) return;
        
        const data = await response.json();
        const currentBuildId = data.buildId;
        
        if (initialBuildId === null) {
          // First check, just record the ID
          initialBuildId = currentBuildId;
        } else if (currentBuildId && initialBuildId !== currentBuildId) {
          // Build ID changed!
          setHasUpdate(true);
        }
      } catch (err) {
        // Ignore fetch errors to avoid console noise
      }
    };

    // Check automatically in prod, bypass in dev so we don't spam requests
    if (import.meta.env.PROD) {
      // Check immediately, then every 5 minutes
      checkForUpdates();
      const interval = setInterval(checkForUpdates, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, []);

  if (!hasUpdate) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] bg-ink border border-ink-600 text-paper px-5 py-4 rounded-lg shadow-overlay flex items-center gap-5">
      <div className="flex flex-col">
        <span className="text-[13px] font-semibold text-paper">Update available</span>
        <span className="text-[11px] text-paper/60 mt-0.5">A new version of Oracle Insight is ready.</span>
      </div>
      <button 
        onClick={() => window.location.reload()} 
        className="flex items-center gap-2 px-3 py-2 bg-paper text-ink font-medium text-[11px] uppercase tracking-wider rounded-md hover:bg-surface transition-colors shrink-0"
      >
        <RotateCcw className="w-3.5 h-3.5" />
        Reload
      </button>
    </div>
  );
}
